import { render, staticRenderFns } from "./SideNavigationMenu.vue?vue&type=template&id=792f0935&"
import script from "./SideNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./SideNavigationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports